import { NodeViewWrapper } from "@tiptap/react";
import { MentionType } from "app/components/TextEditor/components/mentionSuggestion";
import React, { FC } from "react";

const UserMentionNode: FC<{
  type: MentionType;
  label: string;
}> = ({ label, type }) => {
  return (
    <NodeViewWrapper
      as="span"
      contentEditable={false}
      className="text-sm font-regular text-primary"
      data-target-type={type}
    >
      {`@${label}`}
    </NodeViewWrapper>
  );
};

export default UserMentionNode;
